import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ItemMenuSidebar from './ItemMenuSidebar';

const SidebarMenu = (props) => {
    return (
        <aside className="main-sidebar">
            <section className="sidebar .style-sidebar">
                <ul className="sidebar-menu tree" data-widget="tree">
                    <li className="header">Menu</li>
                    <ItemMenuSidebar url={'/'} name={'Inicio'} />
                    <ItemMenuSidebar url={'/users'} name={'Usuarios'} />
                    <ItemMenuSidebar url={'/generators'} name={'Generar Boletos'} />
                    <ItemMenuSidebar url={'/marketplaces'} name={'Plazas'} />
                    <ItemMenuSidebar url={'/lotteries'} name={'Sorteos'} />
                    <ItemMenuSidebar url={'/tickets'} name={'Boletos'} />
                    <ItemMenuSidebar url={'/rewards'} name={'Premios'} />
                    <ItemMenuSidebar url={'/logout'} name={'Salir'} onClick={() => {
                        props.dispatch({
                            type: 'setUsuario',
                            payload: {},
                        });
                    }} />
                </ul>
            </section>
        </aside>
    )
}

const mapStateToProps = (state, props) => {
    return { ...props, usuario: state.usuario };
}

export default withRouter(connect(mapStateToProps)(SidebarMenu))